import React from "react";
import { TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchInput = ({
    placeholder = "Search...",
    value,
    onChange,
    width = 250,
    height = 50,
    size = "small",
    sx = {}, // receive custom sx prop
}) => {
    return (
        <TextField
            variant="outlined"
            size={size}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <SearchIcon color="action" />
                    </InputAdornment>
                ),
            }}
            sx={{
                backgroundColor: "#fff",
                borderRadius: 1,
                width: width,
                "& .MuiOutlinedInput-root": {
                    height: height,
                    borderRadius: "8px",
                },
                "& .MuiInputBase-input": {
                    fontSize: "16px",
                },
                ...sx, // merge external styles
            }}
        />
    );
};

export default SearchInput;
